import { REDEEM_GIFT_CODE_BASE_ROUTE } from "@stadium/shared/src/constants/routes";
import { MY_POINTS_WALLET_ROUTE, MY_SHOP_POINTS_HISTORY_ROUTE } from "@stadium/constants/routes";

export const GIFT_CODE_REDEMPTION_LEARN_MORE_URL =
  "https://help.bystadium.com/hc/en-us/articles/38179121643671-How-to-Redeem-a-Gift-via-Stadium-Gift-Code";

export const getGiftRedeemSuccessStaticCards = (isShopLinkedGiftCode) => [
  {
    title: "Have more gift cards?",
    description: "Add another one to your balance in seconds.",
    route: REDEEM_GIFT_CODE_BASE_ROUTE,
    ctaText: "Redeem",
  },
  {
    title: "Points History",
    description: "View your points history and total balance.",
    route: isShopLinkedGiftCode ? MY_SHOP_POINTS_HISTORY_ROUTE : MY_POINTS_WALLET_ROUTE,
    ctaText: "View History",
  },
];
